import { faFilter } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { Offcanvas } from "react-bootstrap";
import { FaBoxOpen } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { getAllProductsLoder } from "../../features/products/productsSlice";
import { getAllWishlist } from "../../features/wishlist/wishlistSlice";
import Loader_Lottie from "../animation/Loader_Lottie/Loader_Lottie";
import Common_breadcrumb from "../common-components/common-breadcrumb/Common_breadcrumb";
import Product_filter from "./product-filter/Product_filter";
import Search_products from "./search-products/Search_products";
import Frames_card from "../common-components/common-card/frame-card/Frames_card";
import Pagination_Holder from "../common-components/pagination_holder/Pagination_Holder";
import "./All_products.css";
import { getAllPriceRange } from "../../features/master/masterSlice";
import VirtualTryOn from "../virtual-try-on/Virtual_try_on";
import { get2DImage, get3DImage } from "../../utils/common";

const All_products = ({
  handleFilterReset,
  filters,
  handleFilterChange,
  handleSearchCategorySelect,
  setPrice,
  price,
}) => {
  const [show, setShow] = useState(false);
  const dispatch = useDispatch();

  const topframes = useSelector((state) => state.product.allProductsLoder);

  const [onPageChange, setOnPageChange] = useState(
    Number(topframes?.current_page) || 1,
  );
  const [totalPages, setTotalPages] = useState(1);
  const [loder, setLoder] = useState(false);
  const [showTryOn, setShowTryOn] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const priceRange = useSelector((state) => state.master.price_range);
  const is_signin = useSelector((state) => state.auth.is_signin);

  const filtersString = JSON.stringify(filters);
  const priceString = JSON.stringify(price);

  // Scroll to top when page changes
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [onPageChange]);

  // Get products
  useEffect(() => {
    dispatch(
      getAllProductsLoder({
        filters,
        page: onPageChange,
        price,
        setLoder,
      }),
    );
  }, [filtersString, priceString, onPageChange, dispatch]);

  // Set pagination data
  useEffect(() => {
    if (topframes && topframes.data) {
      setTotalPages(topframes.total_pages);
      // setOnPageChange(topframes.current_page);
    }
  }, [topframes]);

  // Wishlist
  useEffect(() => {
    if (is_signin) {
      dispatch(getAllWishlist());
    }
  }, [dispatch, is_signin]);

  // Price range
  useEffect(() => {
    dispatch(getAllPriceRange());
  }, [dispatch]);

  // Reset the search keyword when leaving this page (e.g. navigating to a
  // product detail page), so clicking Back shows the full product list
  // again instead of the last single-product search result.
  useEffect(() => {
    return () => {
      handleFilterChange("name", "");
      handleFilterChange("productId", "");
    };
  }, []);

  const handlePageChange = (pageNumber) => {
    setOnPageChange(pageNumber);
  };

  // const votImage =
  //   process.env.REACT_APP_IMAGE_URL +
  //   get2DImage(selectedProduct?.Product_Images || '');

  const vtoImage = get3DImage(selectedProduct?.Product_Images) || ''

  return (
    <>
      <section className="all_products_sec">
        {/*<Common_breadcrumb
          items={[{ label: "Home", link: "/" }, { label: "Collection" }]}
        />*/}

        <div className="container">
          <div className="row">
            {/* LEFT FILTER */}
            <div className="col-lg-3">
              <div className="filtersec">
                <Product_filter
                  filters={filters}
                  onFilterChange={handleFilterChange}
                  setPrice={setPrice}
                  handleFilterReset={handleFilterReset}
                />
              </div>
            </div>

            {/* RIGHT PRODUCTS */}
            <div className="col-lg-9 mt-2">
              <div className="rightsec">
                <Search_products
                  onClick={() => setShow(true)}
                  filters={filters}
                  onFilterChange={handleFilterChange}
                  onCategorySelect={handleSearchCategorySelect}
                />

                {/* PRODUCTS */}
                <div className="cards_sec_holder">
                  <div className="row">
                    {topframes?.data && topframes.data.length > 0 ? (
                      topframes.data.map((data, index) => (
                        <div
                          key={index}
                          className="col-lg-3 col-sm-4 col-6 p-2 mb-3"
                        >
                          <Frames_card
                            image={data?.image}
                            id={data?.id}
                            type={data?.p_category?.name}
                            name={data?.name}
                            prise={data?.price}
                            oldprise={data?.mrp}
                            vto_enable={data?.vto_enable}
                            setSelectedProduct={() => {
                              setShowTryOn(true);
                              setSelectedProduct(data);
                            }}
                          />
                        </div>
                      ))
                    ) : loder ? (
                      <div className="col-12 text-center p-5">
                        <Loader_Lottie />
                        <h5 className="mt-3 text-muted">
                          Loading products, please wait…
                        </h5>
                      </div>
                    ) : (
                      <div className="col-12 text-center p-5">
                        <FaBoxOpen size={50} color="#b0b0b0" />
                        <h5 className="mt-3 text-muted">
                          No products available
                        </h5>
                      </div>
                    )}
                  </div>
                </div>

                {/* PAGINATION */}
                <div className="comon_page_footer">
                  {loder ? (
                    <div className="pagination_div">
                      <Pagination_Holder
                        onPageChange={onPageChange}
                        totalPages={totalPages}
                        handlePageChange={handlePageChange}
                      />
                    </div>
                  ) : (
                    <div className="pagination_div">
                      <Pagination_Holder
                        onPageChange={onPageChange}
                        totalPages={totalPages}
                        handlePageChange={handlePageChange}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* {votImage && (
            <Virtual_try_on_modal
              isOpen={showTryOn}
              onClose={() => {
                setShowTryOn(false);
                setSelectedProduct(null);
              }}
              newGlass={{
                [votImage]: {
                  widthScale: 2.0,
                  heightRatio: 0.55,
                  offsetYFrac: 0.04,
                },
              }}
              category={selectedProduct?.p_category}
              brand={selectedProduct?.Brand}
              size={selectedProduct?.size}
              total_measurements={selectedProduct?.total_measurements}
            />
          )} */}

          <VirtualTryOn
            isOpen={showTryOn}
            onClose={() => setShowTryOn(false)}
            category={selectedProduct?.p_category}
            brand={selectedProduct?.Brand}
            size={selectedProduct?.size}
            total_measurements={selectedProduct?.total_measurements}
            glbModal={vtoImage}
          />
        </div>

        {/* MOBILE FILTER */}
        <Offcanvas
          show={show}
          onHide={() => setShow(false)}
          className="filter_offcanvas"
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>Filter Products</Offcanvas.Title>
          </Offcanvas.Header>

          <Offcanvas.Body>
            <Product_filter
              filters={filters}
              onFilterChange={handleFilterChange}
              setPrice={setPrice}
              handleFilterReset={handleFilterReset}
            />
          </Offcanvas.Body>
        </Offcanvas>
      </section>
    </>
  );
};

export default All_products;
